// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1b0qc","row":"styles_row__117G6"};